import {Injectable} from '@angular/core';
import {AstrofiltParser} from './parsers/astrofilt.parser';
import {BandsParser} from './parsers/bands.parser';
import {DateParser} from './parsers/date.parser';
import {NumberParser} from './parsers/number.parser';
import {FrequencyParser} from './parsers/frequency.parser';
import {RegexParser} from './parsers/regex.parser';
import {SourceResolverParser} from './parsers/source-resolver.parser';
import {DropdownItemsParser} from './parsers/dropdown-items.parser';
import {RaDecParserParser} from './parsers/ra-dec.parser';
import {GalacticParser} from './parsers/galatic.parser';
import {EclipticParser} from './parsers/ecliptic.parser';
import {PublicDataParser} from './parsers/public-data.parser';
import {CalibrationDataParser} from './parsers/calibration-data.parser';
import {SkyObjectTypesParser} from './parsers/sky-object-types.parser';
import {TargetListParser} from './parsers/target-list.parser';
import {MousParser} from './parsers/mous.parser';

export type ElasticParserType =
  'astrofilt'
  | 'bands'
  | 'date'
  | 'number'
  | 'frequency'
  | 'regex'
  | 'source-resolver'
  | 'dropdown-items'
  | 'ra-dec'
  | 'galactic'
  | 'ecliptic'
  | 'public-data'
  | 'calibration-data'
  | 'mous'
  | 'sky-object-types'
  | 'target-list';

export interface ElasticSearchProperty {
  readonly property?: any;
  readonly path?: string;
  readonly isNested?: boolean;
}

export interface ElasticSearchProperties {
  readonly property?: any;
  readonly path?: string;

  readonly [key: string]: any;
}

export interface ElasticParser {
  parseValue(value: any, elasticSearchProperty: ElasticSearchProperty | ElasticSearchProperties): any;
}

@Injectable({providedIn: 'root'})
export class ElasticParserFactory {
  getElasticParser(elasticParserType: ElasticParserType): ElasticParser {
    switch (elasticParserType) {
      case 'astrofilt':
        return new AstrofiltParser();
      case 'bands':
        return new BandsParser();
      case 'date':
        return new DateParser();
      case 'number':
        return new NumberParser();
      case 'frequency':
        return new FrequencyParser();
      case 'regex':
        return new RegexParser();
      case 'source-resolver':
        return new SourceResolverParser();
      case 'dropdown-items':
        return new DropdownItemsParser();
      case 'ra-dec':
        return new RaDecParserParser();
      case 'galactic':
        return new GalacticParser();
      case 'ecliptic':
        return new EclipticParser();
      case 'public-data':
        return new PublicDataParser();
      case 'calibration-data':
        return new CalibrationDataParser();
      case 'mous':
        return new MousParser();
      case 'sky-object-types':
        return new SkyObjectTypesParser();
      case 'target-list':
        return new TargetListParser();
      default:
        return undefined;
    }
  }
}
